import emailjs from "@emailjs/browser";

const getEnv = (key) => (typeof process !== "undefined" ? process.env[key] : undefined);

const SERVICE_ID = getEnv("REACT_APP_EMAILJS_SERVICE_ID");
const PUBLIC_KEY = getEnv("REACT_APP_EMAILJS_PUBLIC_KEY");
const TEMPLATE_CONTACT = getEnv("REACT_APP_EMAILJS_TEMPLATE_CONTACT");
const TEMPLATE_ORDER = getEnv("REACT_APP_EMAILJS_TEMPLATE_ORDER");
// Hardcoded recipient email - always send to info@mehartraders.co.uk
const TO_EMAIL = "info@mehartraders.co.uk";

const isConfigured = () =>
  Boolean(SERVICE_ID && PUBLIC_KEY && TEMPLATE_CONTACT && TEMPLATE_ORDER);

export const emailConfigOk = isConfigured();

export async function sendContactEmail({ name, email, subject, message }) {
  if (!emailConfigOk) {
    throw new Error("EmailJS is not configured");
  }

  return emailjs.send(
    SERVICE_ID,
    TEMPLATE_CONTACT,
    {
      to_email: TO_EMAIL,
      from_name: name,
      reply_to: email,
      subject,
      message,
    },
    { publicKey: PUBLIC_KEY }
  );
}

export async function sendOrderEmail({ orderId, customerName, customerEmail, customerPhone, shippingAddress, paymentMethod, items, total }) {
  if (!emailConfigOk) {
    throw new Error("EmailJS is not configured");
  }

  const itemsText = (items || [])
    .map((i) => `${i?.product?.name || "Item"} x${i?.quantity || 0} @ £${Number(i?.product?.price || 0).toFixed(2)} = £${(Number(i?.product?.price || 0) * (i?.quantity || 0)).toFixed(2)}`)
    .join("\n");

  return emailjs.send(
    SERVICE_ID,
    TEMPLATE_ORDER,
    {
      to_email: TO_EMAIL,
      order_id: orderId,
      customer_name: customerName || "Not provided",
      customer_email: customerEmail || "Not provided",
      customer_phone: customerPhone || "Not provided",
      shipping_address: shippingAddress || "Not provided",
      payment_method: paymentMethod || "Not specified",
      items: itemsText,
      total: `£${Number(total || 0).toFixed(2)}`,
    },
    { publicKey: PUBLIC_KEY }
  );
}




